export class User {
  walletId: number;
  msisdn: string;
  balance: number;
  pointsValue: number;
}
